module.exports = __webpack_public_path__ + "img/wxlogin1.d242d61c.png";